import styled from 'styled-components';
import { black, chartDarkGray } from 'styles/colors';

export const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	padding: 32px 40px;
`;

export const UploadTitle = styled.div`
	font-size: 19px;
	color: ${black};
	font-weight: 500;
	line-height: 27px;
	margin-bottom: 4px;
`;

export const UploadTitleDescription = styled.div`
	color: ${chartDarkGray};
	font-size: 13px;
	letter-spacing: 0.8px;
	line-height: 19px;
`;

export const UploadControlsSection = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 32px;
`;
